export const STATSIG_STABLE_ID_OLD_KEY = 'STATSIG_LOCAL_STORAGE_STABLE_ID';
export const STATSIG_STABLE_ID_NEW_KEY = 'statsig.stable_id.3206961030';
